import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Button, Input, Icon } from "semantic-ui-react";
import Erro from "../layouts/mensagens/Erro";
import InputMask from 'react-text-mask';
import SenhaInput from "../layouts/SenhaInput";
import * as FormValidator from "../../utils/formValidator";

class FormCadastroCliente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        nome: "",
        email: "",
        faculdade: "",
        genero: "",
        celular: "",
        senha: "",
        tipo: "demo"
      },
      etapa: "dados",
      codigo: "",
      segundosReenvio: 0,
      loading: false,
      errors: {}
    }
  }

  componentWillUnmount = () => clearInterval(this.timer);

  iniciarContagem = (segundos = 30) => {
    clearInterval(this.timer);
    this.setState({ segundosReenvio: segundos });
    this.timer = setInterval(() => {
      const restante = this.state.segundosReenvio - 1;
      this.setState({ segundosReenvio: Math.max(restante, 0) });
      if (restante <= 0) clearInterval(this.timer);
    }, 1000);
  };

  getGeneros = () => [
    { key: 'masculino', value: 'masculino', text: 'Masculino' },
    { key: 'feminino', value: 'feminino', text: 'Feminino' },
    { key: 'outro', value: 'outro', text: 'Outro' }
  ]

  onChange = e =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
      errors: {}
    });

  onChangeSelect = (e, { name, value }) =>
    this.setState({
      data: { ...this.state.data, [name]: value },
      errors: {}
    })

  onSubmit = e => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      this.props
        .submit(this.state.data)
        .then(() => {
          this.setState({ loading: false, etapa: "codigo", codigo: "", errors: {} });
          this.iniciarContagem();
        })
        .catch(err =>
          this.setState({
            loading: false,
            errors: { cadastro: FormValidator.getErro(err) }
          })
        );
    }
  };

  onChangeCodigo = e => {
    const codigo = e.target.value.replace(/\D/g, "").slice(0, 6);
    this.setState({ codigo, errors: {} }, () => {
      if (codigo.length === 6) this.onConfirmar();
    });
  };

  onConfirmar = e => {
    if (e) e.preventDefault();
    const { codigo, data, loading } = this.state;
    if (loading) return;
    if (codigo.length !== 6) {
      this.setState({ errors: { codigo: "Digite os 6 dígitos do código" } });
      return;
    }
    this.setState({ loading: true });
    // com sucesso a sessão é aberta e a rota redireciona para o painel
    this.props.confirmar(data.email.trim(), codigo).catch(err =>
      this.setState({
        loading: false,
        codigo: "",
        errors: { codigo: FormValidator.getErro(err) }
      })
    );
  };

  onReenviar = () => {
    if (this.state.segundosReenvio > 0) return;
    this.setState({ loading: true, errors: {} });
    this.props
      .reenviar(this.state.data.email.trim())
      .then(() => {
        this.setState({ loading: false, codigo: "", reenviado: true });
        this.iniciarContagem();
      })
      .catch(err =>
        this.setState({ loading: false, errors: { codigo: FormValidator.getErro(err) } })
      );
  };

  voltar = () => {
    clearInterval(this.timer);
    this.setState({ etapa: "dados", codigo: "", errors: {}, reenviado: false });
  };

  validate = data => {
    const errors = {};
    if (!FormValidator.isNomeCompleto(data.nome)) errors.nome = "Digite seu nome completo";
    if (!FormValidator.isEmail(data.email)) errors.email = "E-mail inválido";
    if (!FormValidator.isSenha(data.senha)) errors.senha = "Sua senha deve conter no mínimo 8 caracteres e pelo menos 1 número e 1 letra";
    if (data.celular)
      if (!FormValidator.isNumeroCelular(data.celular)) errors.celular = "Número de celular inválido";
    return errors;
  };

  renderCodigo = ({ data, errors, loading, codigo, segundosReenvio, reenviado }) => (
    <Form onSubmit={this.onConfirmar} loading={loading} size="large" className="va-cad-codigo">
      <div className="va-cad-icone"><Icon name="mail outline" /></div>
      <h3 className="va-cad-titulo">Confira seu e-mail</h3>
      <p className="va-cad-texto">
        Enviamos um código de 6 dígitos para <b>{data.email.trim()}</b>.
        Digite o código abaixo para concluir o cadastro e entrar.
      </p>
      <Erro tipo="block">{errors.codigo}</Erro>
      <Form.Field error={!!errors.codigo}>
        <input
          id="codigo"
          name="codigo"
          className="va-cad-codigo-input"
          inputMode="numeric"
          autoComplete="one-time-code"
          autoFocus
          maxLength={6}
          placeholder="••••••"
          aria-label="Código de 6 dígitos"
          value={codigo}
          onChange={this.onChangeCodigo}
        />
      </Form.Field>
      <Button icon labelPosition="right" type="submit" fluid className="btn-ui-1" size="large" style={styles.btn}>
        Confirmar e entrar <Icon name="right chevron" />
      </Button>
      <div className="va-cad-links">
        {segundosReenvio > 0
          ? <span>{reenviado ? "Novo código enviado. " : ""}Reenviar código em {segundosReenvio}s</span>
          : <button type="button" className="va-cad-link" onClick={this.onReenviar}>Reenviar código</button>}
        <button type="button" className="va-cad-link" onClick={this.voltar}>Corrigir e-mail</button>
      </div>
      <p className="va-cad-dica">Não chegou? Veja a caixa de spam. O código vale por 15 minutos.</p>
    </Form>
  );

  render() {
    const { data, errors, loading, etapa } = this.state;
    if (etapa === "codigo") return this.renderCodigo(this.state);
    const senha = data.senha;
    const regras = [
      { ok: senha.length >= 8, texto: "8 ou mais caracteres" },
      { ok: /[a-zA-Z]/.test(senha), texto: "1 letra" },
      { ok: /\d/.test(senha), texto: "1 número" }
    ];
    return (
      <Form onSubmit={this.onSubmit} loading={loading} size="large">
        <p className="va-cad-texto va-cad-intro">
          Preencha seus dados. Em seguida, enviaremos um código de 6 dígitos para o seu e-mail; ao digitá-lo, você já entra no sistema.</p>
        <Erro tipo="block">{errors.cadastro}</Erro>
        <Form.Group widths={"equal"}>
          <Form.Field error={!!errors.nome} required>
            <label htmlFor="nome">Nome do Administrador</label>
            <Input>
              <input
                type="text"
                id="nome"
                name="nome"
                autoComplete="name"
                placeholder="Nome e sobrenome"
                value={data.nome}
                onChange={this.onChange}
              />
            </Input>
            <Erro text={errors.nome} />
          </Form.Field>
          <Form.Field error={!!errors.email} required>
            <label htmlFor="email">E-mail</label>
            <Input>
              <input
                type="email"
                id="email"
                name="email"
                autoComplete="email"
                placeholder="exemplo@exemplo.com"
                value={data.email}
                onChange={this.onChange}
              />
            </Input>
            <Erro text={errors.email} />
          </Form.Field>
        </Form.Group>
        <Form.Group widths={"equal"}>
          <Form.Field error={!!errors.genero}>
            <Form.Select
              fluid
              label='Gênero'
              name="genero"
              options={this.getGeneros()}
              onChange={this.onChangeSelect}
              value={data.genero}
              placeholder='Gênero'
            />
            <Erro text={errors.genero} />
          </Form.Field>
          <Form.Field error={!!errors.celular}>
            <label htmlFor="celular">Celular</label>
            <InputMask
              type="text"
              id="celular"
              name="celular"
              placeholder="(ddd) número"
              mask={['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              guide={true}
              value={data.celular}
              onChange={this.onChange}
            />
            <Erro text={errors.celular} />
          </Form.Field>
        </Form.Group>
        <Form.Field error={!!errors.senha} required>
          <label htmlFor="senha">Senha</label>
          <SenhaInput
            placeholder="Crie uma senha"
            id="senha"
            name="senha"
            autoComplete="new-password"
            value={data.senha}
            onChange={this.onChange}
          />
          <div className="va-cad-regras">
            {regras.map(r => (
              <span key={r.texto} className={r.ok ? "ok" : ""}>
                <Icon name={r.ok ? "check circle" : "circle outline"} /> {r.texto}
              </span>
            ))}
          </div>
          <Erro text={errors.senha} />
        </Form.Field>
        <Button icon labelPosition='right' type="submit" fluid className="btn-ui-1" size="large" style={styles.btn}>
          Continuar <Icon name='right chevron' />
        </Button>
      </Form>
    );
  }
}

const styles = {
  btn: {
    marginTop: "20px",
    marginBottom: "10px"
  }
}

FormCadastroCliente.propTypes = {
  submit: PropTypes.func.isRequired
};

export default FormCadastroCliente;
